import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=5020e002&"
import script from "./GoodsInfo.vue?vue&type=script&lang=js&"
export * from "./GoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports